import React from "react";
import { number } from "prop-types";
import { Notification } from "@cxagroup/casper";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { Link } from "react-router-dom";
import { RouteMap } from "components/common/navigation/routeMap";

const UnreadMessageNotification = ({ count }) => (
  <Notification level="notification">
    <FormattedMessage
      {...messages.inAppMessages.unreadMessageNotification}
      values={{
        link: <Link to={RouteMap.InAppMessageHome}>here</Link>,
        count,
      }}
    />
  </Notification>
);

UnreadMessageNotification.propTypes = {
  count: number.isRequired,
};

export default UnreadMessageNotification;



// WEBPACK FOOTER //
// ./components/inAppMessages/UnreadMessageNotification.js